import { render, staticRenderFns } from "./widget-template-gallery.vue?vue&type=template&id=1da5791c&scoped=true&"
import script from "./widget-template-gallery.vue?vue&type=script&lang=js&"
export * from "./widget-template-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5791c",
  null
  
)

export default component.exports